import React, { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

interface TableLoadingSkeletonProps {
  expanded?: boolean;
}

export const TableLoadingSkeleton: FC<TableLoadingSkeletonProps> = ({
  expanded = false,
}: TableLoadingSkeletonProps) => {
  if (!expanded) {
    return (
      <Box
        sx={{
          height: '100%',
          width: '100%',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: 1 }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Tabs Skeleton */}
      <Stack direction="row" spacing={1}>
        <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
      </Stack>

      {/* Table Rows Skeleton */}
      <Stack spacing={1} sx={{ flex: 1 }}>
        {[...Array(10)].map((_: unknown, index: number) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={25}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Stack>
    </Box>
  );
};
